import React, { ReactNode } from 'react';
import styles from './FilterBoxes.module.scss';
import Button from '@src/components/button/Button';
import IconRotating from '@src/assets/icons/rotating_arrow.svg?react';

type FilterBoxesProps = {
  mainFilterContent: ReactNode;
  actionButtonContent?: ReactNode;
  onReset?: () => void;
  resetButtonLabel?: string;
  resultsCount?: number;
  resultsCountLabel?: string;
  hasAdvancedFilters?: boolean;
  hasSearchInput?: boolean;
  hideResetButton?: boolean;
  showDivider?: boolean;
};

/**
 * FilterBoxes - A component that displays two separate boxes side by side:
 * 1. Main filter box (left) containing search and dropdown filters
 * 2. Side box (right) containing the Reset button and results count
 */
const FilterBoxes: React.FC<FilterBoxesProps> = ({
  mainFilterContent,
  actionButtonContent,
  onReset,
  resetButtonLabel = 'Reset',
  resultsCount,
  resultsCountLabel = 'Results',
  hasAdvancedFilters = false,
  hasSearchInput = true,
  hideResetButton = false,
  showDivider = true
}) => {

  return (
    <div className={styles.filterBoxesContainer}>
      <div className={styles.twoColumnLayout}>
        <div className={`${styles.leftColumn} ${!hasAdvancedFilters ? styles.singleRowContent : ''}`}>
          {mainFilterContent}
        </div>
        
        {showDivider && (
          <div className={styles.dividerColumn}>
            <div className={styles.verticalDivider}></div>
          </div>
        )}
        
        {actionButtonContent && (
          <div className={styles.rightColumn}>
            {actionButtonContent}
          </div>
        )}
      </div>
      
      <div className={styles.sideFilterBox}>
        {onReset && !hideResetButton && (
          <Button
            onClick={onReset}
            className={styles.resetBtn}
            label={resetButtonLabel}
            size="extraSmall"
            outline={true}
            color="green"
            leftIcon={<IconRotating className={styles.resetIcon} />}
          />
        )}
        <div className={styles.resultCount}>
          {resultsCount !== undefined && (
            <>
              <span className={styles.resultsCountNumber}>{resultsCount}</span> {resultsCountLabel}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterBoxes;
